/** @deprecated - this is moved to libs */
export enum ScenarioCode {
    DamageFreeYears = 'SJVG',   // Schadevrije jaren vragen
    VehicleReplacement = 'VEVO',   // Vervangen
    CompareAddressDetails = 'VZWA',   // Vergelijken opgegeven adresgegevens met het woonadres die bij ons bekend is.
    CompareAddressStartDate = 'VZID'    // Vergelijken opgegeven ingangsdatum met de ingangsdatum van het toekomstig
    // woonadres die bij ons bekend is of in de ingangsdatum van het woonadres in de input.
}
